document.addEventListener('DOMContentLoaded', function() {
  const tickerWrapper = document.querySelector('.wedding_ticker');
  if (tickerWrapper) {
    const items = tickerWrapper.querySelectorAll('.ticker_item');
    let totalWidth = 0;

    // Calculate the total width of all items, including any margins
    items.forEach(item => {
      const style = window.getComputedStyle(item);
      const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
      totalWidth += item.offsetWidth + margin;
    });

    // Clone items and append directly to the tickerWrapper for seamless continuity
    items.forEach(item => {
      const clone = item.cloneNode(true);
      tickerWrapper.appendChild(clone);
    });

    let currentPosition = 0;
    const scrollSpeed = .5; // Adjust for desired scroll speed

    function animate() {
      if (!isPaused) {
        currentPosition -= scrollSpeed;
        
        // Reset position when it scrolls past the original total width
        if (Math.abs(currentPosition) >= totalWidth) {
          currentPosition += totalWidth;
        }

        tickerWrapper.style.transform = `translateX(${currentPosition}px)`;
        requestAnimationFrame(animate);
      }
    }

    let isPaused = false; // Flag to control pause state

    // Uncomment if you want to pause on hover
    // tickerWrapper.addEventListener('mouseenter', () => isPaused = true);
    // tickerWrapper.addEventListener('mouseleave', () => isPaused = false);

    animate(); // Initiate the animation
  }
});

/*
  Ringfinder
*/

document.addEventListener('DOMContentLoaded', function() {
  // Function to get a cookie value by name
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  // Function to set a cookie
  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }

  // Function to toggle visibility and opacity
  function toggleVisibility() {
    const step1 = document.querySelector('.w_ringfinder_step1');
    const step2 = document.querySelector('.w_ringfinder_step2');
    const actionButton = document.querySelector('.w_ringfinder_action');

    if (step1 && step2 && actionButton) {
      // Toggle 'active' class to switch visibility
      step1.classList.toggle('active');
      step2.classList.toggle('active');
      actionButton.classList.toggle('active', step2.classList.contains('active'));

      // Update cookie based on visibility
      setCookie('view', step2.classList.contains('active') ? 'step2' : 'step1', 7);
    }
  }

  // Function to set initial view based on cookie
  function setInitialView() {
    const view = getCookie('view');
    const step1 = document.querySelector('.w_ringfinder_step1');
    const step2 = document.querySelector('.w_ringfinder_step2');
    const actionButton = document.querySelector('.w_ringfinder_action');

    if (view === 'step2') {
      step1.classList.remove('active');
      step2.classList.add('active');
      actionButton.classList.add('active');
    } else {
      step1.classList.add('active');
      step2.classList.remove('active');
      actionButton.classList.remove('active');
    }
  }

  // Initialize the view based on the current cookie
  setInitialView();

  // Selector for the ring finder
  const selector = document.querySelector('.w_selector');
  const actionButton = document.querySelector('.w_ringfinder_action');

  if (selector && actionButton) {
    // Attach click event listener to .w_selector
    selector.addEventListener('click', function(e) {
      e.preventDefault();
      toggleVisibility();
    });

    // Attach click event listener to .w_ringfinder_action
    actionButton.addEventListener('click', function(e) {
      e.preventDefault();
      toggleVisibility();
    });
  }
});



